import React from 'react';
import '../styling/About.css';
import AssamEmblem from '../assets/emblems/Assam.svg';
import MeghalayaEmblem from '../assets/emblems/Meghalaya.svg';
import MizoramEmblem from '../assets/emblems/MIzoram.svg';
import NagalandEmblem from '../assets/emblems/Nagaland.svg';
import SikkimEmblem from '../assets/emblems/Sikkim.svg';
import TripuraEmblem from '../assets/emblems/Tripura.svg';
import WestBengalEmblem from '../assets/emblems/WestBengal.svg';

const About: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <div className="about-header">
        <div className="container">
          <h1 className="about-title">About Travelisk</h1>
          <p className="about-subtitle">
            Your trusted travel companion for unforgettable adventures
          </p>
        </div>
      </div>

      <div className="container">
        {/* Company Story Section */}
        <section className="company-story">
          <div className="story-content">
            <h2 className="section-title">Our Story</h2>
            <p className="story-text">
              Travelisk was born from a passion for travel and a desire to make extraordinary experiences 
              accessible to everyone. Founded with the vision of creating seamless, memorable journeys, 
              we have been helping travelers discover the world's most beautiful destinations while 
              ensuring comfort, safety, and unforgettable memories.
            </p>
            <p className="story-text">
              Our team of travel experts carefully curates each package, ensuring that every detail 
              is perfect for your dream vacation. From the bustling streets of metropolitan cities 
              to the serene beaches of tropical paradises, we bring you closer to the world's wonders.
            </p>
          </div>
          <div className="story-stats">
            <div className="stat-item">
              <h3 className="stat-number">200+</h3>
              <p className="stat-label">Happy Travelers</p>
            </div>
            <div className="stat-item">
              <h3 className="stat-number">10+</h3>
              <p className="stat-label">Destinations</p>
            </div>
            <div className="stat-item">
              <h3 className="stat-number">2+</h3>
              <p className="stat-label">Years Experience</p>
            </div>
          </div>
        </section>

        {/* Google Reviews Section */}
        <section className="google-reviews">
          <h2 className="section-title">What Our Customers Say</h2>
          <p className="section-subtitle">Read authentic reviews from our Google Business Profile</p>
          
          <div className="reviews-grid">

            <div className="review-card">
              <div className="review-header">
                <div className="reviewer-info">
                  <h4 className="reviewer-name">Gaurab</h4>
                  <div className="review-stars">⭐⭐⭐⭐⭐</div>
                </div>
                <div className="review-date">1 month ago</div>
              </div>
              <p className="review-text">
                "The Meghalaya trip with Travelisk was fantastic, featuring excellent hotel stays, a thoughtfully planned itinerary, and delicious food throughout. Every detail was well-managed, creating a smooth and comfortable experience from arrival to departure. The accommodations were both comfortable and conveniently located, and the variety of local cuisine was a highlight of the trip. Overall, it was a wonderful travel experience that exceeded expectations."
              </p>
            </div>

          <div className="review-card">
              <div className="review-header">
                <div className="reviewer-info">
                  <h4 className="reviewer-name">Sanghita</h4>
                  <div className="review-stars">⭐⭐⭐⭐⭐</div>
                </div>
                <div className="review-date">2 month ago</div>
              </div>
              <p className="review-text">
                "An awesome experience happened with Travelisk. It was a much needed one. We could have never been such satisfied without their guidance. We would always recommend #Travelisk for every travel assistance. Good luck & much love for the team. An incredible tour planner from Northeast for the whole of India. Thank you from the core of our hearts. ❤️"
              </p>
            </div>

            <div className="review-card">
              <div className="review-header">
                <div className="reviewer-info">
                  <h4 className="reviewer-name">Suparna</h4>
                  <div className="review-stars">⭐⭐⭐⭐⭐</div>
                </div>
                <div className="review-date">3 month ago</div>
              </div>
              <p className="review-text">
                "Travelisk this is a well guided traveller platform... Few days ago we visited KALIMPONG guidance of travelisk... But we customized our package. Owner of the travelisk behavior too good and servicing mind blowing. We haven't faced any problem among the travelling period. When I called him , quickly he response.
                Another trip of my life I must to go with this traveller... Their guidance and communication got enough courage and feel free to enjoy my trip..."
              </p>
            </div>

            <div className="review-card">
              <div className="review-header">
                <div className="reviewer-info">
                  <h4 className="reviewer-name">Arghya</h4>
                  <div className="review-stars">⭐⭐⭐⭐</div>
                </div>
                <div className="review-date">3 month ago</div>
              </div>
              <p className="review-text">
                "1. Good hospitality<br />
                2. Better management<br />
                3. Experience driver<br />
                4. Better accomodation"
              </p>
            </div>

            <div className="review-card">
              <div className="review-header">
                <div className="reviewer-info">
                  <h4 className="reviewer-name">Dorothi</h4>
                  <div className="review-stars">⭐⭐⭐⭐⭐</div>
                </div>
                <div className="review-date">4 month ago</div>
              </div>
              <p className="review-text">
                "I had a fantastic time on my recent trip to Darjeeling, all thanks to Travelisk. The itinerary was perfect, but the highlight was definitely the hotel. The room was excellent and had a breathtaking view of the mountains."
              </p>
            </div>
          </div>

          <div className="google-reviews-cta">
            <p className="cta-text">Want to read more reviews?</p>
            <a 
              href="https://share.google/uTQ3Rot7Gbk0Skig9" 
              target="_blank" 
              rel="noopener noreferrer"
              className="google-reviews-button"
            >
              View All Reviews on Google
            </a>
          </div>
        </section>

        {/* Team Testimonials Section */}
        <section className="team-testimonials">
          <h2 className="section-title">Meet Our Team</h2>
          <p className="section-subtitle">The passionate people behind your perfect travel experiences</p>
          
          <div className="team-grid">

            <div className="team-member">
              <div className="member-photo">
                <img 
                  className="member-photo-img"
                  src="https://res.cloudinary.com/daowsh3q5/image/upload/v1758558298/ak_cvxulo.jpg" 
                  alt="Priya Chatterjee" 
                  onError={(e) => {
                      e.currentTarget.style.display = 'none';
                      e.currentTarget.parentElement!.innerHTML = '<div class="photo-placeholder">👩‍💼</div>';
                    }}
                />
              </div>
              <div className="member-info">
                <h3 className="member-name">Arghyadeep Das</h3>
                <p className="member-role">Co-Founder & Operation Head</p>
                <p className="member-bio">
                As Operations Head at Travelisk, I focus on creating seamless travel experiences by curating the best itineraries, transparent budgets, and detailed destination insights. Every trip is designed to offer our guests comfort, connection, and a truly memorable journey, making Travelisk a trusted choice for travellers.
                </p>
                <div className="member-expertise">
                  <span className="expertise-tag">Itinerary Planning</span>
                  <span className="expertise-tag">Local Expertise</span>
                  <span className="expertise-tag">Customer Care</span>
                </div>
              </div>
            </div>

            <div className="team-member">
              <div className="member-photo">
                <img 
                  className="member-photo-img"
                  src="https://res.cloudinary.com/daowsh3q5/image/upload/v1758558386/mm_xeooxg.jpg" 
                  alt="Debarshi Das" 
                  onError={(e) => {
                      e.currentTarget.style.display = 'none';
                      e.currentTarget.parentElement!.innerHTML = '<div class="photo-placeholder">👨‍💼</div>';
                    }}
                />
              </div>
              <div className="member-info">
                <h3 className="member-name">Debarshi Das</h3>
                <p className="member-role">Co-Founder & IT Head</p>
                <p className="member-bio">
                As IT Head at Travelisk, I ensure our website and digital platforms deliver seamless, user-friendly experiences. Behind every interaction, I focus on connecting travellers with the best destinations and tourism insights, making Travelisk reliable, accessible, and engaging for every guest.
                </p>
                <div className="member-expertise">
                  <span className="expertise-tag">Destination Planning</span>
                  <span className="expertise-tag">Customer Relations</span>
                  <span className="expertise-tag">Business Strategy</span>
                </div>
              </div>
            </div>

            <div className="team-member">
              <div className="member-photo">
                <img 
                  className="member-photo-img"
                  src="https://res.cloudinary.com/daowsh3q5/image/upload/v1758557586/photo_tr5to8.jpg" 
                  alt="Arjun Sen" 
                  onError={(e) => {
                      e.currentTarget.style.display = 'none';
                      e.currentTarget.parentElement!.innerHTML = '<div class="photo-placeholder">👨‍�</div>';
                    }}
                />
              </div>
              <div className="member-info">
                <h3 className="member-name">Bishal K. Das</h3>
                <p className="member-role">Co-Founder & Creative Head</p>
                <p className="member-bio">
                As Graphic Head at Travelisk, I ensure every visual is designed with clarity and purpose. With patience and creativity, I focus on making complex travel details easy to understand while showcasing the beauty of tourism. Each design is crafted to enhance the traveler’s experience and reflect Travelisk’s commitment to excellence.
                </p>
                <div className="member-expertise">
                  <span className="expertise-tag">Operations</span>
                  <span className="expertise-tag">Logistics</span>
                  <span className="expertise-tag">Partner Relations</span>
                </div>
              </div>
            </div>

            <div className="team-member">
              <div className="member-photo">
                <img 
                  className="member-photo-img"
                  src="https://res.cloudinary.com/daowsh3q5/image/upload/v1758558840/an_xtar3k.jpg" 
                  alt="Sneha Banerjee" 
                  onError={(e) => {
                      e.currentTarget.style.display = 'none';
                      e.currentTarget.parentElement!.innerHTML = '<div class="photo-placeholder">👩‍💻</div>';
                    }}
                />
              </div>
              <div className="member-info">
                <h3 className="member-name">Saptadeep Das</h3>
                <p className="member-role">Co-Founder & Social Media Manager</p>
                <p className="member-bio">
                At Travelisk, I used my experience as a Social Media Manager to develop and implement a content strategy that greatly enhanced our online presence. Through an emphasis on engaging storytelling and high-impact visuals, I am able to effectively showcase a diverse set of destinations, driving higher engagement and building our base of travellers.
                </p>
                <div className="member-expertise">
                  <span className="expertise-tag">Customer Support</span>
                  <span className="expertise-tag">Problem Solving</span>
                  <span className="expertise-tag">Quality Assurance</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Government Tourism Bodies Acknowledgment */}
        <section className="government-acknowledgment">
          <h2 className="section-title">Our Partners & Recognition</h2>
          <p className="section-subtitle">
            We are proud to be recognized and supported by various government tourism bodies
          </p>
          
          <div className="acknowledgment-content">
            <div className="acknowledgment-text">
              <p>
                Travelisk is honored to work in partnership with various government tourism 
                organizations and regulatory bodies that promote responsible and sustainable 
                tourism practices. We extend our heartfelt gratitude to:
              </p>
            </div>

            <div className="tourism-bodies">
              <div className="body-item">
                <div className="body-logo">
                  <img src={WestBengalEmblem} alt="West Bengal Tourism" className="emblem-logo" />
                </div>
                <div className="body-info">
                  <h3 className="body-name">West Bengal Tourism</h3>
                  <p className="body-description">
                    For showcasing the rich cultural heritage, diverse landscapes from the Himalayas to the Bay of Bengal
                  </p>
                </div>
              </div>

              <div className="body-item">
                <div className="body-logo">
                  <img src={AssamEmblem} alt="Assam Tourism" className="emblem-logo" />
                </div>
                <div className="body-info">
                  <h3 className="body-name">Assam Tourism</h3>
                  <p className="body-description">
                    For promoting the gateway to Northeast India, home to Kaziranga, tea gardens, and the mighty Brahmaputra
                  </p>
                </div>
              </div>

              <div className="body-item">
                <div className="body-logo">
                  <img src={MeghalayaEmblem} alt="Meghalaya Tourism" className="emblem-logo" />
                </div>
                <div className="body-info">
                  <h3 className="body-name">Meghalaya Tourism</h3>
                  <p className="body-description">
                    For preserving the abode of clouds with its living root bridges, pristine waterfalls, and vibrant tribal culture
                  </p>
                </div>
              </div>

              <div className="body-item">
                <div className="body-logo">
                  <img src={SikkimEmblem} alt="Sikkim Tourism" className="emblem-logo" />
                </div>
                <div className="body-info">
                  <h3 className="body-name">Sikkim Tourism</h3>
                  <p className="body-description">
                    For maintaining the Himalayan paradise with views of Kanchenjunga, Buddhist monasteries, and organic farming heritage
                  </p>
                </div>
              </div>

              <div className="body-item">
                <div className="body-logo">
                  <img src={NagalandEmblem} alt="Nagaland Tourism" className="emblem-logo" />
                </div>
                <div className="body-info">
                  <h3 className="body-name">Nagaland Tourism</h3>
                  <p className="body-description">
                    For celebrating the land of festivals, rich Naga tribal heritage, and the legendary Hornbill Festival
                  </p>
                </div>
              </div>

              <div className="body-item">
                <div className="body-logo">
                  <img src={MizoramEmblem} alt="Mizoram Tourism" className="emblem-logo" />
                </div>
                <div className="body-info">
                  <h3 className="body-name">Mizoram Tourism</h3>
                  <p className="body-description">
                    For showcasing the land of blue mountains, rolling hills, vibrant Mizo culture, and warm hospitality
                  </p>
                </div>
              </div>

              <div className="body-item">
                <div className="body-logo">
                  <img src={TripuraEmblem} alt="Tripura Tourism" className="emblem-logo" />
                </div>
                <div className="body-info">
                  <h3 className="body-name">Tripura Tourism Development Corporation</h3>
                  <p className="body-description">
                    For promoting the land of diverse tribes, ancient palaces, and the magnificent Ujjayanta Palace heritage
                  </p>
                </div>
              </div>
            </div>

            <div className="acknowledgment-footer">
              <p>
                We are committed to following all tourism guidelines and regulations set by these 
                esteemed organizations. Our partnership with these bodies ensures that we provide 
                authentic, responsible, and sustainable travel experiences while contributing to 
                the growth of tourism in India.
              </p>
            </div>
          </div>
        </section>

        {/* Mission & Values Section */}
        <section className="mission-values">
          <div className="mission-content">
            <h2 className="section-title">Our Mission & Values</h2>
            <div className="values-grid">
              <div className="value-item">
                <div className="value-icon">🎯</div>
                <h3 className="value-title">Mission</h3>
                <p className="value-description">
                  To make extraordinary travel experiences accessible to everyone while promoting 
                  sustainable tourism and supporting local communities.
                </p>
              </div>
              
              <div className="value-item">
                <div className="value-icon">⭐</div>
                <h3 className="value-title">Quality</h3>
                <p className="value-description">
                  We maintain the highest standards in service delivery, accommodation, and 
                  transportation to ensure your complete satisfaction.
                </p>
              </div>
              
              <div className="value-item">
                <div className="value-icon">🤝</div>
                <h3 className="value-title">Trust</h3>
                <p className="value-description">
                  Building lasting relationships through transparency, reliability, and 
                  honest communication with our valued customers.
                </p>
              </div>
              
              <div className="value-item">
                <div className="value-icon">🌱</div>
                <h3 className="value-title">Sustainability</h3>
                <p className="value-description">
                  Committed to responsible tourism practices that protect the environment 
                  and benefit local communities.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
